<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="justify-center mt-3">
            <v-col cols="3">
                <v-text-field
                v-model="form.filters.descricao"
                label="Descrição do Material"
                outlined
                dense
                ></v-text-field>
            </v-col>
            <v-col cols="3">
                <v-text-field
                v-model="form.filters.formacao"
                label="Formação"
                outlined
                dense
                ></v-text-field>
            </v-col>
            <v-col cols="3">
                <v-autocomplete
                    v-model="form.filters.disciplinaId"
                    label="Disciplina"
                    outlined
                    dense
                    :items="disciplinas"
                    item-text="nomeDisciplina"
                    item-value="id"
                  />
            </v-col>
        </v-row>
        <v-row class="justify-center mt-3">
            <v-col cols="3">
                <v-autocomplete
                    v-model="form.filters.formato"
                    label="Formato"
                    outlined
                    dense
                    :items="$tiposAnexos"
                    item-text="descricao"
                    item-value="value"
                  />
            </v-col>
            <v-col cols="3">
                <v-text-field
                v-model="form.filters.responsavel"
                label="Responsável"
                outlined
                dense
                ></v-text-field>
            </v-col>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sigfoco-tooltip
              text="Buscar"
              icon="mdi-magnify"
              @click="buscarMaterial()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              text="Limpar"
              icon="mdi-eraser"
              @click="resetForm()"
            ></sigfoco-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="table.headers"
        :items="table.itens"
        :items-per-page="10"
        :footer-props="$footerProps"
      >
        <template v-slot:[`item.formatos`]="{ item }">
            {{ Array.isArray(item.formatos) ? item.formatos.join(', ') : '' }}
        </template>

        <template v-slot:[`item.acoes`]="{ item }">
          <sigfoco-tooltip
            text="Baixar Material"
            icon="mdi-download"
            small
            @click="baixarMaterial(item)"
          ></sigfoco-tooltip>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import { Dialog } from "~/commons/classes/dialog";
import ManterMaterialService from "~/services/manter-material.service"
import ManterDownload from "~/services/download.service"
import ManterDisciplinaService from "~/services/manter-disciplina.service";
import UtilMixin from "~/mixins/util.mixin";
export default {
  name: "ManterBancoDeMateriaisPelosFormadoresView",
  mixins: [ManterMaterialService, ManterDownload, ManterDisciplinaService, UtilMixin],
  data: () => ({
    expanded: [],
    dialogManterMaterial: Dialog.Build(),
    form:{
      filters: {
        descricao: null,
        formacao: null,
        disciplinaId: null,
        formato: null,
        responsavel: null
      },
    },
    disciplinas: [],
    table: {
      headers: [
        { text: "Descrição do Material", align: "center", value: "descricao" },
        { text: "Formação", align: "center", value: "formacao" },
        { text: "Disciplina", align: "center", value: "disciplina" },
        { text: "Formato", align: "center", value: "formatos" },
        { text: "Responsável", align: "center", value: "responsavel" },
        { text: "Data de Upload", align: "center", value: "dataDeUploadFormatada" },
        { text: "Ação", align: "center", value: "acoes", sortable: false },
      ],
      itens: [],
    }
  }),
  methods: {
    buscarMaterial() {
      this.$listarBancoDeMaterial({ params: this.form.filters }).then(
        ({ data }) => this.table.itens = data.lista
      )
    },
    resetForm() {
      this.$resetForm();
      this.expanded = [];
      this.table.itens = [];
      this.form.filters.ativo = null;
    },
    $baixarRelatorioZIP(bytes, nomeDoRelatorio = "relatorio") {
      const blob = new Blob([bytes], { type: "application/zip" });
      const a = document.createElement("a");
      const url = URL.createObjectURL(blob);
      a.href = url;
      a.download = `${nomeDoRelatorio}.zip`;
      a.click();
      URL.revokeObjectURL(url);
      this.$notifySuccess("Operação realizada com sucesso!");
    },
    baixarMaterial(item) {
      if (item.isDownloadZip) {
        this.$baixarMaterialZip(item.id).then(response => {
          const nomeArquivoCodificado = response.headers["nome-arquivo"];
          const nomeArquivo = decodeURIComponent(nomeArquivoCodificado);
          this.$baixarRelatorioZIP(response.data, nomeArquivo);
        }).catch((e) => {
          console.error("Erro ao baixar o arquivo zipado:", e);
          this.$notifyError("Erro ao baixar o arquivo zipado.");
        });
      } else if (item.path) {
        const params = this.$montarParamsFilters({ path: item.path, anexoId: item.id });
        this.$downloadArquivos(params).then(({ data }) => {
          const nomeArquivo = item.path.split("\\").pop();
          const file = new File([data], nomeArquivo);
          const blob = new Blob([file], { type: file.type || "application/octet-stream" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = nomeArquivo;
          link.click();
          URL.revokeObjectURL(link.href);
          this.$notifySuccess("Operação realizada com sucesso!");
        }).catch(() => {
          this.$notifyError("Erro ao baixar o anexo individual.");
        });
      } else {
        this.$notifyWarning("Arquivo não disponível para download.");
      }
    },

  },
  mounted() {
    this.$buscarDisciplina().then(({ data }) => {
      this.disciplinas = data.lista.filter(disciplina => disciplina?.ativo);
    });
  }
}
</script>